import { Injectable } from '@angular/core';
import { ReferenceDataConstants } from '../../lib/constants/reference-data-constants';
import { ReferenceDataOptionLists } from '../../lib/constants/reference-data-option-lists';
import { AnsweredQuestionViewModel } from '../models/answered-question-viewmodel.model';

@Injectable()
export class AdvisedEligibilityValidatorService {
  public validateBuyToLetQuestions(
    questions: Array<AnsweredQuestionViewModel>,
    propertyLocation: string,
    interestOnly: string,
    interestOnlyValidAssets: string
  ): boolean {
    return (
      this.validateDynamicQuestions(questions) &&
      this.validateInterestOnly(interestOnly, interestOnlyValidAssets) &&
      propertyLocation !== undefined
    );
  }

  public validateHelpToBuyQuestion(canBeNichaApplication: boolean, helpToBuy: string): boolean {
    if (helpToBuy === ReferenceDataOptionLists.AnswerTypeYes) {
      return canBeNichaApplication;
    }

    return true;
  }

  public validateNichaQuestionQuestion(canBeNichaApplication: boolean, isNichaApplication: string): boolean {
    if (canBeNichaApplication) {
      return isNichaApplication === ReferenceDataOptionLists.AnswerTypeYes;
    }

    return true;
  }

  public validateResidentialQuestions(questions: Array<AnsweredQuestionViewModel>, propertyLocation: string): boolean {
    return (
      this.validateDynamicQuestions(questions) && propertyLocation !== ReferenceDataOptionLists.PropertyLocationNone
    );
  }

  protected validateInterestOnly(interestOnly: string, interestOnlyValidAssets: string): boolean {
    if (interestOnly === ReferenceDataOptionLists.AnswerTypeYes) {
      return interestOnlyValidAssets === ReferenceDataOptionLists.AnswerTypeYes;
    }

    return interestOnly === ReferenceDataOptionLists.AnswerTypeNo;
  }

  protected validateDynamicQuestions(questions: Array<any>): boolean {
    for (const question of questions) {
      if (!this.isAnsweredAcceptably(question)) {
        return false;
      }
    }

    return true;
  }

  private isAnsweredAcceptably(question: AnsweredQuestionViewModel): boolean {
    if (!question) {
      return false;
    }

    for (const attribute of question.Attributes) {
      if (
        attribute.Name.toLowerCase() === ReferenceDataConstants.AcceptedAnswer &&
        this.isAnswerWithinAcceptableValues(question.ProvidedAnswer, attribute.Values)
      ) {
        return true;
      }
    }

    return false;
  }

  private isAnswerWithinAcceptableValues(providedAnswer: string, acceptableValues: Array<string>): boolean {
    if (!providedAnswer || !acceptableValues) {
      return false;
    }

    for (const acceptableValue of acceptableValues) {
      if (acceptableValue && acceptableValue.toLowerCase() === providedAnswer.toLowerCase()) {
        return true;
      }
    }

    return false;
  }
}
